// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__22YIJ","header":"PatientBlock_header__24ykj","label":"PatientBlock_label__1m-Wi","option":"PatientBlock_option__3fdmQ"};